module.exports = __webpack_public_path__ + "img/HUD-scheme-teal-blue.3d154e1f.jpg";